import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'demand-by-day-component',
  templateUrl: './demand-by-day.component.html',
  styleUrls: ['./demand-by-day.component.scss']
})
export class DemandByDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
